/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function useTimeout(callback: () => void, delay: number): () => void {
  const id = setTimeout(callback, delay);
  const cancel = (): void => clearTimeout(id);

  /*                                                                                                                                       */
  $effect(() => cancel);

  /*                                                                */
  return cancel;
}
